import React from "react";
import moment from "moment";

import "./index.scss";

const getInitials = (firstName = "", lastName = "") => {
	const firstInitial = firstName?.trim()?.charAt(0) || "";
	const lastInitial = lastName?.trim()?.charAt(0) || "";
	const initials = `${firstInitial}${lastInitial}`.trim();
	return initials || "MR";
};

export default function MedicalRecordCard(props) {
	const {element} = props;
	const player = element?.playerData || {};
	const firstName = player?.firstName || "";
	const lastName = player?.lastName || "";
	const fullName = `${firstName} ${lastName}`.trim() || "---";
	const birthYear = player?.dateOfBirth
		? moment(player.dateOfBirth).format("YYYY")
		: null;
	const category = player?.category || null;
	const lastUpdate = element?.updatedAt || element?.createdAt || null;

	const metaItems = [category, birthYear].filter(Boolean);

	return (
		<div className="medical-record-card">
			<div className="medical-record-card__tab">
				<span className="medical-record-card__tab-title">Cartella medica</span>
				{lastUpdate ? (
					<span className="medical-record-card__tab-date">
						Agg. {moment(lastUpdate).format("DD/MM/YYYY")}
					</span>
				) : null}
			</div>
			<div className="medical-record-card__body">
				<div className="medical-record-card__avatar">
					{getInitials(firstName, lastName)}
				</div>
				<div className="medical-record-card__info">
					<div className="medical-record-card__name">{fullName}</div>
					<div className="medical-record-card__meta">
						{metaItems.length
							? metaItems.map((item, index) => (
									<span key={`${item}-${index}`} className="meta-chip">
										{item}
									</span>
								))
							: "---"}
					</div>
				</div>
				<div className="medical-record-card__chevron">{">"}</div>
			</div>
		</div>
	);
}
